import dayjs from 'dayjs'

import { Icons } from '../../components/atoms/Icon'
import { RecipeHeroDetailsProps } from '../../components/molecules/RecipeHeroDetails'
import type { Recipe } from '../../graphql/generated/api-graphql'
import { transformTimeToMinutes } from '../../helpers/DateHelpers'
import { toScoreLetter } from '../Common/recipe'

const RecipeHeroDetailsTransform = (
  t: any,
  data: Recipe
): RecipeHeroDetailsProps => {
  const prepTime = data?.preparationTime
    ? transformTimeToMinutes(data.preparationTime)
    : 0
  const cookTime = data?.cookingTime
    ? transformTimeToMinutes(data.cookingTime)
    : 0
  return {
    score: {
      value: toScoreLetter(data?.nutriscoreLetterV2 ?? data.nutriscoreLetter),
      isV2: !!data.nutriscoreLetterV2,
    },
    isPositive: data.positiveFood,
    entries: [
      ...((prepTime && prepTime > 0) || data?.tagsPreparationTime?.[0]?.name
        ? [
            {
              icon: Icons.timer,
              label: t('preparation'),
              value:
                prepTime > 0
                  ? t('recipe_duration', { duration: prepTime })
                  : data.tagsPreparationTime[0].name,
            },
          ]
        : []),
      ...((cookTime && cookTime > 0) || data?.tagsCookingTime?.[0]?.name
        ? [
            {
              icon: Icons.cooking,
              label: t('cooking'),
              value:
                cookTime > 0
                  ? t('recipe_duration', { duration: cookTime })
                  : data.tagsCookingTime[0].name,
            },
          ]
        : []),
      ...(data?.tagsBudget?.[0]?.name
        ? [
            {
              icon: Icons.euro,
              label: t('budget'),
              value: data.tagsBudget[0].name,
            },
          ]
        : []),
    ],
    ...(data.publicationDate || data.updatedAt
      ? {
          date: {
            text: data.updatedAt
              ? t('updated_the', {
                  date: dayjs(data.updatedAt, 'YYYY-MM-DD HH:mm:ss').format(
                    'DD/MM/YYYY'
                  ),
                })
              : t('published_the', {
                  date: dayjs(
                    data.publicationDate,
                    'YYYY-MM-DD HH:mm:ss'
                  ).format('DD/MM/YYYY'),
                }),
            time: data.updatedAt
              ? dayjs(data.updatedAt).format('YYYY-MM-DD')
              : dayjs(data.publicationDate).format('YYYY-MM-DD'),
          },
        }
      : {}),
  }
}

export default RecipeHeroDetailsTransform
